import { createAsyncThunk } from "@reduxjs/toolkit";
import { Category } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindCategory, GetCategory } from "../../category/api/interface";

export const findSelectCategory = createAsyncThunk(
  "selectCategory/findSelectCategory",
  async (values: FindCategory, { rejectWithValue }) => {
    try {
      const response = await Category.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectCategory = createAsyncThunk(
  "selectCategory/searchSelectCategory",
  async (values: FindCategory, { rejectWithValue }) => {
    try {
      const response = await Category.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectCategory = createAsyncThunk(
  'selectCategory/getSelectCategory',
  async ({ id }: GetCategory, { rejectWithValue }) => {
    try {
      const response = await Category.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
